<template>
  <keep-alive>
    <router-view :key="$route.fullPath"></router-view>
  </keep-alive>
</template>

<script>
  export default {
    name: 'participantSingleWrapper',
  };
</script>

<style>
</style>
